export const DECISION_SUCCESS = 'SUCCESS';
export const DECISION_ABANDON = 'ABANDON';
